import React from 'react';
import ButtonWhite from '../../../../components/ButtonWhite/ButtonWhite';
import Action from '../../redux/Action';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-multi-lang';
import { setIncompletedProducts, setSelectedIncompletedProduct } from '../../redux/Reducer';

const CancelConfirmation = ({
    onCancel
}) => {
    const dispatch = useDispatch();
    const t = useTranslation();
    return (
        <div className="fixed inset-0 z-10 overflow-y-auto">
            <div
                className="fixed inset-0 w-full h-full bg-black opacity-40"
                onClick={() => onCancel()}
            />
            <div className="flex items-center min-h-screen px-4 py-8">
                <div className="relative w-full max-w-lg p-4 mx-auto bg-gray-primary rounded-xl shadow-lg">
                    <h3 className="text-green-primary font-bold mb-1">Cancel Bulk Add Products</h3>
                    <p className=" text-[#7D8786] font-['Plus_Jakarta_Sans'] font-medium text-sm tracking-normal">
                        Are you sure you want to cancel the bulk addition of products? By doing so, all the products will be deleted
                    </p>
                    <div className="flex justify-end gap-2 mt-3">
                        <ButtonWhite
                            title={t("general.cancel")}
                            onClick={() => onCancel()}
                        />
                        <button
                            onClick={() => {
                                dispatch(setIncompletedProducts([]));
                                dispatch(setSelectedIncompletedProduct(null));
                                Action.getPage(dispatch, { page: "all" });
                            }}
                            className={`button md:w-36 hover:bg-gray-primary hover:text-green-secondary text-xs tracking-widest font-bold text-gray-primary border-2 border-green-secondary bg-green-secondary border-opacity-40 rounded-xl py-2`}
                        >
                            {t("general.confirm")}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CancelConfirmation;